import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { Card, Row, Col, Modal, Layout, Result, Table, Tabs } from 'antd';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import PageHeader from "../../components/PageHeader";
import { iconMapping } from "../../configs/AppsConfig";
import { getBuildersMenuItems } from "./builderMenuConfig";
import FileUploadComponent from "../../components/Files/FileUploadComponent";
import {FileUploadRounded} from "@mui/icons-material";
import { extractPortfoliosFromFile } from "../../api/inferenceApi";
import {selectAllBuilderUploadFilenames, setActiveBuilder, setNewPortfolioBuilderContext} from "../../store/slices/builder.slice";
import BuilderUploadInstance from "./BuilderUploadInstance";
import ImageCard from "../../components/ImageCard";
import ContentNavigator from "../../components/ContentNavigator";
import ContentView from "../../components/ContentView";
import useBuilderDrafts from "./useBuilderDrafts";


const BuildersLanding = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [builderUploadVisible, setBuilderUploadVisible] = useState(false);
    const uploadedBuilderFilenames = useSelector(selectAllBuilderUploadFilenames);
    const uploadsInProgress = useSelector(state=>state.builder.fileUploadsInProgress);
    const {data} = useBuilderDrafts();


    console.log(uploadedBuilderFilenames)

    const closeModal = () => setIsModalVisible(false);

    const onNewPortfolio = (type) => {
        if (type === 'upload') {
            // Handle file import
            setIsModalVisible(true);
        } else {
            dispatch(setNewPortfolioBuilderContext({ type }));
            navigate('/builders/portfolio');
        }
    };


    const gridItems = getBuildersMenuItems(onNewPortfolio);
      const sectionConfig = [
            {
                title: "Building the Basics",
                items: [
                    {
                        title: "Getting Started",
                        text: "Get familiar with the basics and the interactive ways you can build.",
                        onClick: () => console.log("Clicked: SMA vs ETFs")
                    },
                    {
                        title: "Combining Processes",
                        text: "Learn how you can combine processes to create unique solutions for each client",
                        onClick: () => console.log("Clicked: SMA vs ETFs")
                    },
                ]
            },
          {
                title: "Managers Touch",
                items: [
                    {
                        title: "Long Duration Yields",
                        text: "Take your fixed income to the next level with long duration strategies",
                        onClick: () => console.log("Clicked: SMA vs ETFs")
                    },
                    {
                        title: "Risk Reward Balance",
                        text: "Learn how you can use data driven processes to help stabilize client portfolios during volatility",
                        onClick: () => console.log("Clicked: SMA vs ETFs")
                    },
                ]
            },
  ];
  const linksConfig = [
            {label: "Whats Happening in the Market"},
            {label: "ETFs vs Stock SMAs"},
  ];


    const ContentScroll = ()=>(
        <>
            {gridItems.map((item, index) => (
                <ImageCard title={item.title}
                           description={item.description}
                           imgUrl={item.imgUrl}
                           action={<Button variant={'outlined'} onClick={()=>onNewPortfolio(item.type)}>Use Now</Button>}
                />
            ))}
        </>
    )
    const handleTabChange = (key) => {
        if (key.startsWith('state_')) {
            const stateId = key.split('_')[1];
            dispatch(setActiveBuilder({stateId}));
            navigate('/builders/portfolio');
        }
    }
    return (
        <>
            <PageHeader title={'Builders'} icon={iconMapping.portfolioBuilder}/>
            <div style={{height: '100vh'}}>
                <Tabs centered={true} onTabClick={handleTabChange}>
                    <Tabs.TabPane key={'1'} tab={'Builder Home'}>
                        <Layout.Content style={{padding: '2.5%'}}>
                            <Row align={'top'}>
                                <ContentView content={<ContentScroll/>}
                                             navigator={<ContentNavigator sectionsConfig={sectionConfig}
                                                                          linksConfig={linksConfig}
                                                                          topAction={<Button variant={'contained'}
                                                                                             style={{ marginBottom: '15px', width: '100%' }}
                                                                                             onClick={() => setIsModalVisible(true)}
                                                                                             startIcon={<FileUploadRounded/>}

                                                                                     >Upload a Portfolio</Button>}
                                                        />
                                            }
                                />

                            </Row>
                        </Layout.Content>
                    </Tabs.TabPane>
                    {data.length > 0 && (
                        data.map((item, index) => (
                            <Tabs.TabPane key={`state_${item.stateId}`} tab={item?.name && item.name !== "" ? item.name : `Unnamed (${index+1})`} closeable={true}/>
                        ))
                    )
                    }
                    {uploadedBuilderFilenames.length > 0 &&
                        uploadedBuilderFilenames.map((filename, index) => (
                            <Tabs.TabPane key={index + 2} tab={filename} closeable={true}>
                                <BuilderUploadInstance filename={filename}/>
                            </Tabs.TabPane>
                        ))
                    }
                </Tabs>

            </div>

            <Modal
                title="Upload Portfolio File"
                open={isModalVisible}
                onCancel={closeModal}
                footer={null}
            >
                <FileUploadComponent thunkAction={extractPortfoliosFromFile}
                                     onSuccessCallback={()=>setBuilderUploadVisible(false)}
                                     filesInProgress={uploadsInProgress}
                />
            </Modal>
        </>
    );
};

export default BuildersLanding;
